import jr from "assets/images/banners/orthoInternal/jointreplacement.jpg";
import ss from "assets/images/banners/orthoInternal/spinesurgery.jpg";
import tkr from "assets/images/banners/orthoInternal/totalkneereplacement.jpg";
import ft from "assets/images/banners/orthoInternal/fracturedtreatement.jpg";

import jrI from "assets/images/banners/orthoInternalBanner/jrs.png";
import ssI from "assets/images/banners/orthoInternalBanner/ss.png";
import tkrI from "assets/images/banners/orthoInternalBanner/tkp.png";
import ftI from "assets/images/banners/orthoInternalBanner/ft.png";

export const internalData = [
  {
    id: "jointReplacement",
    label: "Joint Replacement Surgery",
    img: jr,
    banner: jrI,
    data: [
      {
        header: "What is Joint Replacement Surgery",
        content:
          "Joint replacement surgery involves removing damaged or diseased parts of a joint and replacing them with artificial components. Commonly performed on hips and knees, this surgery helps relieve pain and restore function, allowing you to return to a normal, active life.",
        points: null,
      },
      {
        header: "Is Joint Replacement Surgery Right for You?",
        content:
          "Joint replacement is ideal for individuals experiencing chronic joint pain and reduced mobility due to conditions like arthritis or injury. Consider this surgery if:",
        points: [
          "You're over 55 and have joint pain that limits your daily activities.",
          "You experience significant pain after exercise.",
          "Stiffness in your joints affects your quality of life.",
          "Non-surgical treatments like medication and physical therapy no longer provide relief.",
        ],
      },
      {
        header: "What Types of Joint Replacement Surgeries Are Available?",
        content: null,
        points: [
          "Total Hip Replacement: Replaces the hip joint to relieve pain from arthritis or injury.",
          "Knee Joint Replacement: Resurfaces the knee for patients with severe arthritis or knee injuries.",
          "Shoulder Joint Replacement: Reduces pain and restores mobility in damaged shoulder joints.",
          "Revision Surgeries: Address issues with previous joint replacements, ensuring long-term success.",
        ],
      },
      {
        header: "How is Joint Replacement Surgery Done?",
        content:
          "The procedure involves removing the damaged joint and replacing it with a prosthesis made of metal, ceramic, or plastic. This prosthetic joint mimics the natural joint's movement, providing stability and pain relief. The surgery is performed with precision to ensure optimal results.",
        points: [
          "Minimally Invasive Techniques: Small incisions for less tissue damage.",
          "Advanced Technology: High precision in prosthesis placement.",
          "Faster Recovery: Early mobilization and quicker return to daily activities.",
        ],
      },
    ],
  },
  {
    id: "spineSurgery",
    label: "Spine Surgery",
    img: ss,
    banner: ssI,
    data: [
      {
        header: "What is Spine Surgery?",
        content:
          "Spine Surgery encompasses a range of surgical procedures aimed at addressing issues related to the spine. These procedures are designed to alleviate chronic back pain, correct spinal deformities, and improve overall spinal function. Advanced surgical techniques and technology enable precise intervention to restore mobility and enhance the quality of life for patients.",
        points: null,
      },
      {
        header: "Is Spine Surgery Right for You?",
        content:
          "Spine Surgery is ideal for individuals experiencing severe and persistent back pain that significantly impacts their daily activities. It is particularly suitable for those who:",
        points: [
          "Suffer from Chronic Back Pain: If you have ongoing pain that limits your ability to perform everyday tasks.",
          "Seek Pain Relief: Ideal for those who have not found relief through non-surgical treatments.",
          "Experience Neurological Symptoms: Suitable for individuals with nerve compression symptoms such as numbness, tingling, or weakness.",
        ],
      },
      {
        header: "What Types of Spine Surgeries Are Available?",
        content: null,
        points: [
          "Discectomy: Removes a portion of a herniated or damaged disc to alleviate nerve compression and pain.",
          "Spinal Fusion: Stabilizes the spine by joining two or more vertebrae, often used for conditions like spinal instability or severe arthritis.",
          "Laminectomy: Involves removing a part of the vertebral bone (lamina) to relieve pressure on the spinal cord or nerves, commonly used for spinal stenosis.",
          "Foraminotomy: Expands the opening where nerves exit the spinal canal, relieving nerve compression.",
          "Artificial Disc Replacement: Replaces a damaged disc with a synthetic one, maintaining spinal flexibility and motion.",
          "Microdiscectomy: A minimally invasive procedure to remove part of a herniated disc, reducing nerve pressure and pain.",
          "Kyphoplasty and Vertebroplasty: Procedures to stabilize and repair compression fractures in the spine, often due to osteoporosis.",
        ],
      },
      {
        header: "How is Spine Surgery Done?",
        content:
          "Spine Surgery involves various techniques depending on the specific condition being treated. Common procedures include:",
        points: [
          "Discectomy: Removing part of a herniated disc to relieve nerve pressure.",
          "Spinal Fusion: Joining two or more vertebrae to stabilize the spine.",
          "Laminectomy: Removing part of the vertebral bone to alleviate spinal cord or nerve pressure.",
          "Minimally Invasive Options: Utilizing small incisions and advanced imaging for precise, less invasive interventions.",
        ],
      },
    ],
  },
  {
    id: "totalKneeReplacement",
    label: "Total Knee Replacement",
    img: tkr,
    banner: tkrI,
    data: [
      {
        header: "What is Total Knee Replacement?",
        content:
          "Total Knee Replacement Surgery, also known as knee arthroplasty, is a procedure designed to replace damaged or worn-out knee joints with artificial components. This surgery aims to relieve pain, restore function, and improve the overall quality of life for individuals suffering from severe knee conditions. By utilizing advanced surgical techniques, this procedure ensures precise and effective outcomes, allowing patients to regain mobility and lead active lives.",
        points: null,
      },
      {
        header: "Is Total Knee Replacement Right for You?",
        content:
          "Total Knee Replacement Surgery is ideal for individuals experiencing significant knee pain and mobility issues due to conditions such as osteoarthritis, rheumatoid arthritis, or post-traumatic arthritis. It is particularly suitable for those who:",
        points: [
          "Suffer from Chronic Knee Pain: Persistent pain that limits daily activities and affects the quality of life.",
          "Seek Improved Mobility: Struggle with walking, climbing stairs, or performing everyday tasks due to knee stiffness and discomfort.",
          "Desire Long-Term Relief: Looking for a durable solution to regain normal knee function and alleviate chronic pain.",
        ],
      },
      {
        header: "What Types of Knee Replacements Are Available?",
        content: null,
        points: [
          "Total Knee Replacement: The most common type, replacing both sides of the knee joint with artificial components.",
          "Partial Knee Replacement: Replaces only the affected part of the knee, preserving more of the natural bone and tissues.",
          "Patellofemoral Replacement: Focuses on replacing the under-surface of the kneecap and the groove it slides in.",
          "Complex Knee Replacement: Required for patients with severe arthritis or those who have undergone multiple knee surgeries.",
          "Cartilage Restoration: Replaces damaged cartilage with healthy tissue to repair and restore knee function.",
        ],
      },
      {
        header: "How is Total Knee Replacement Done?",
        content:
          "Total Knee Replacement Surgery involves the removal of damaged knee surfaces and the implantation of artificial components designed to replicate the natural movement of the knee. The procedure typically includes the following steps:",
        points: [
          "Bone Preparation: Removal of damaged cartilage and bone from the knee joint.",
          "Implant Placement: Insertion of metal and plastic components to replace the removed sections.",
          "Patella Adjustment: The underside of the kneecap may be resurfaced for a better fit.",
          "Spacer Insertion: A plastic spacer is placed between the metal components to ensure smooth movement.",
        ],
      },
    ],
  },
  {
    id: "fractureTreatment",
    label: "Fracture Treatment",
    img: ft,
    banner: ftI,
    data: [
      {
        header: "Understanding Fracture Treatment",
        content:
          "Fracture treatment involves the care and management of broken bones to ensure proper healing and recovery. It encompasses various methods tailored to the severity and type of fracture, aiming to restore the bone’s normal function as efficiently as possible.",
        points: null,
      },
      {
        header: "When To Get Fracture Treatment",
        content:
          "Fracture treatment is essential for anyone who has suffered a broken bone, whether due to an accident, fall, or underlying medical condition. The goal is to provide a pain-free recovery with minimal disruption to daily activities.",
        points: [
          "Immediate Care: Crucial for individuals experiencing severe pain, swelling, or deformity due to a suspected fracture.",
          "Quick Recovery: Ideal for those needing to resume their normal activities quickly, often with non-surgical options.",
          "Comprehensive Solutions: Suitable for people of all ages, from children with greenstick fractures to elderly individuals with osteoporosis-related breaks.",
        ],
      },
      {
        header: "Types of Fractures",
        content: null,
        points: [
          "Avulsion Fracture: Occurs when a ligament or tendon pulls off a piece of bone.",
          "Closed vs. Open Fractures: Closed fractures do not break the skin, whereas open fractures involve a break in the skin.",
          "Comminuted Fracture: The bone is shattered into multiple pieces.",
          "Complete vs. Partial Fractures: Complete fractures separate the bone into two parts, while partial fractures do not fully break the bone.",
          "Stress Fracture: Caused by repetitive stress, common among athletes.",
          "Pathological Fracture: Results from weakened bones due to conditions like osteoporosis or cancer.",
        ],
      },
      {
        header: "How Is Fracture Treatment Performed?",
        content:
          "Fracture treatment varies based on the fracture's complexity and location, involving both non-surgical and surgical methods to ensure optimal healing.",
        points: [
          "Non-Surgical Options: Includes immobilization using casts, splints, or braces to support and protect the bone during healing.",
          "Surgical Interventions: For severe fractures, surgery may involve the use of pins, plates, screws, or rods to stabilize the bone.",
          "Pain Management: Effective pain relief strategies are implemented to ensure patient comfort throughout the healing process.",
        ],
      },
    ],
  },
];

export const list = [
  {
    id: "jointReplacement",
    label: "Joint Replacement Surgery",
    content: "datamap",
  },
  {
    id: "spineSurgery",
    label: "Spine Surgery",
    content: "datamap",
  },
  {
    id: "totalKneeReplacement",
    label: "Total Knee Replacement",
    content: "datamap",
  },
  {
    id: "fractureTreatment",
    label: "Fracture Treatment",
    content: "datamap",
  },
];

export const listheader = "Our Orthopedic Services";

export const orthoInternal = { list, internalData, listheader };
